module.exports = __webpack_public_path__ + "img/2018-09-3.90283737.jpeg";